import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { ConvertUtil } from '@app/common/util/convert.util';
import { CartUtil } from '@app/common/util/cart.util';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { Store } from '@ngrx/store';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { CartState } from '@app/selectors/shoppingmall/cart.selector';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { addToCart, setIsBuyNow, setShowAlert } from '@app/actions/shoppingmall/cart.action';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { CommonConstant } from '@app/common/constant/common.constant';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(
    private _http: HttpClient,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _wAlertStore: Store<WAlertState>,
    private _cartStore: Store<CartState>) { 

  }

  loadCartItems(userid: string, ordNoTmp: any): Observable<OrdPdtModel[]> {
    let url = `${environment.apiUrl}/ordreg/cart-list?comid=${environment.comId}&userid=${userid}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<OrdPdtModel[]>(url);
  }

  loadCartInfo(userid: string, ctrCd: string, page:number, len:number): Observable<OrderMstModel[]> {
    let url = `${environment.apiUrl}/ordreg/cart-info?comid=${environment.comId}&userid=${userid}&ctrCd=${ctrCd}&page=${page}&len=${len}`;
    return this._http.get<OrderMstModel[]>(url);
  }

  loadOneCartInfo(userid: string, ctrCd: string, ordNoTmp: any): Observable<OrderMstModel> {
    let url = `${environment.apiUrl}/ordreg/one-cart-info?comid=${environment.comId}&userid=${userid}&ctrCd=${ctrCd}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<OrderMstModel>(url);
  }

  countCartInfo(userid: string): Observable<OrderMstModel[]> {
    let url = `${environment.apiUrl}/ordreg/count-cart-info?comid=${environment.comId}&userid=${userid}`;
    return this._http.get<OrderMstModel[]>(url);
  }

  addToCartItem(params: any): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/tmp-save`;
    return this._http.post<ResultProc>(url, {...params, lang: environment.default_lang});
  }

  removeCartItem(userid: string, pdtCd: string, ordNoTmp: number): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/cart-del?comid=${environment.comId}&userid=${userid}&pdtCd=${pdtCd}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<ResultProc>(url);
  }

  cancelOrder(userid: string, ordNoTmp: number): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/tmp-del?comid=${environment.comId}&userid=${userid}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<ResultProc>(url);
  }

  loadAllCartItems(userid: string): Observable<OrdPdtModel[]> {
    let url = `${environment.apiUrl}/ordreg/all-pdt-tmp?comid=${environment.comId}&userid=${userid}`;
    return this._http.get<OrdPdtModel[]>(url);
  }

  loadCartInfoNotLogin(ordNoTmp: number): Observable<OrderMstModel>{
    let url = `${environment.apiUrl}/ordreg/cart-info-not-login?comid=${environment.comId}&ordNoTmp=${ordNoTmp}&ctrCd=${environment.default_lang}`;
    return this._http.get<OrderMstModel>(url);
  }

  addCartItemNotLogin(item: any, quantity: number) {
    let tmp: any = [];
    let cardInfoTmp: any = sessionStorage.getItem("cardInfoTmp");
    let linkCart: any = sessionStorage.getItem("linkCart");

    if (Number(item.amt) <= 0) {
      this.showAlertPriceInvalid();
      return;
    }

    if (quantity > 0) {
      if(ValidationUtil.isNotNullAndNotEmpty(linkCart)) {
        tmp = JSON.parse(linkCart);
        if(tmp.cateNameOrg == 'O06') {
          if(item.cateNameOrg == 'O06') {
            this.handleAddCartItemToLinkCart(item, quantity, tmp);
          } else {
            this.showAlertNotOtherProduct();
            return;
          }
        } else {
          if(item.cateNameOrg == 'O06') {
            this.showAlertNotPointProduct();
            return;
          } else {
            this.handleAddCartItemToLinkCart(item, quantity, tmp);
          }
        }    
      } else {
        if(ValidationUtil.isNotNullAndNotEmpty(cardInfoTmp)) {
          tmp = JSON.parse(cardInfoTmp);
          if(tmp[0].cateNameOrg == 'O06') { 
            if(item.cateNameOrg == 'O06') {
              let data = {};
              for(let i = 0 ; i < tmp.length; i++) {
                if(item.pdtCd == tmp[i].pdtCd) {
                  data = CartUtil.getParamsAddToCartNotLogin(item, tmp[i].qty + quantity);
                  
                  tmp.splice(i, 1);
                } else {
                  data = CartUtil.getParamsAddToCartNotLogin(item, quantity);
                } 
              }
              tmp.push(data);
            } else {
              this.showAlertNotOtherProduct();
              return;
            }
          } else {
            if(item.cateNameOrg == 'O06') {
              this.showAlertNotPointProduct();
              return;
            } else {
              let data = {};
              for(let i = 0; i < tmp.length; i++) {
                if(item.pdtCd == tmp[i].pdtCd) {
                  data = CartUtil.getParamsAddToCartNotLogin(item, tmp[i].qty + quantity);
                  tmp.splice(i, 1);
                } else {
                  data = CartUtil.getParamsAddToCartNotLogin(item, quantity);
                } 
              }
              tmp.push(data);
            }
          }
          
        } else {
          let data = CartUtil.getParamsAddToCartNotLogin(item, quantity);
          tmp.push(data);
        }
        sessionStorage.setItem(CommonConstant.CART_INFO_TMP, JSON.stringify(tmp));
        this.showAlertAddCartSuccess();
      }
    } else {
      this.showAlertRequiredQuantityInvalid();
    }
    window.dispatchEvent(new Event('storage'));
  }

  handleAddCartItemToLinkCart(item: any, quantity: number, cartTmp: any) {
    this._wAlertStore.dispatch(clearWAlert());
    let params = CartUtil.getParamsAddToLinkCart(cartTmp, ConvertUtil.convertToSring(item.pdtCd), quantity);

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._cartStore.dispatch(setShowAlert({ show: true }));
    this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
    this._cartStore.dispatch(addToCart({ params: params }));

    let linkCartProducts: any = sessionStorage.getItem(CommonConstant.LINK_CART_PRODUCTS);
    let linkCartParse = JSON.parse(linkCartProducts); 
    if(linkCartParse.length === 0) {
      sessionStorage.setItem(CommonConstant.LINK_CART_PRODUCTS, JSON.stringify(item));
    } else {
      let linkCartFiltered = linkCartParse.filter((b: { pdtCd: any; }) => b.pdtCd == item.pdtCd)[0];

      if (ValidationUtil.isNotNullAndNotEmpty(linkCartFiltered)) {
        linkCartParse.map((b: { pdtCd: any; qty: number; }) => {
          if (b.pdtCd == linkCartFiltered.pdtCd) {
            b.qty = (Number(b.qty) + 1);
          }
          return b;
        });
        
      } else {
        let ordProduct = {
          pdtCd : item.pdtCd,
          qty : 1
        }
        linkCartParse.push(ordProduct);
      }
      sessionStorage.setItem(CommonConstant.LINK_CART_PRODUCTS, JSON.stringify(linkCartParse));
    }
  }

  addCartItemLogin(item: any, quantity: number, cartInfo: any) {    
    let pdtCd = ConvertUtil.convertToSring(item.pdtCd);
    let cateNameOrg = ConvertUtil.convertToSring(item.cateNameOrg);
    if (+item.amt <= 0) {
      this.showAlertPriceInvalid();
      return;
    }
    if (quantity > 0) {          
      if(cartInfo.length > 0) {
        this.showListOrdTmp(pdtCd, quantity, cartInfo, cateNameOrg);           
      } else {
        this.handleAddCartItemLogin(pdtCd, quantity, '');
      }
    } else {
      this.showAlertRequiredQuantityInvalid();
    }
  }

  handleAddCartItemLogin(pdtCd: string, quantity: number, ordNoTmp: string) {
    this._wAlertStore.dispatch(clearWAlert());
    let params = CartUtil.getParamsAddToCart(pdtCd, quantity, ordNoTmp);

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._cartStore.dispatch(setShowAlert({ show: true }));
    this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
    this._cartStore.dispatch(addToCart({ params: params }));
  }

  buyItemNow(item: any, quantity: number) {
    let params: any;
    let userid = '';
    let cntCd = '';
    let userKindCd = '';
    let consumer = AuthUtil.getInfoUserId2();      
    if (consumer) {
      console.log(consumer)
      userid = ConvertUtil.convertToString(consumer.userid);
      cntCd = ConvertUtil.convertToString(consumer.cntCd); 
      userKindCd = "U10";
    } else {
      userid = environment.comCd + "00000000";
      cntCd = environment.comCd + "001";
      userKindCd = "U00";
    }

    if (!ValidationUtil.isNotNullAndNotEmpty(item)) {
      item = JSON.parse(sessionStorage.getItem(CommonConstant.CART_INFO_TMP) || "");
      let listMstDto: any [] = [];

      for(let i = 0; i < item.length; i++) {
        let data = {
          comId: environment.comId,
          userid: userid,
          userKindCd: userKindCd,
          cntCd: cntCd,
          pathCD: environment.comCd + "T30",
          pdtCd: item[i].pdtCd,
          qty: item[i].qty,
          workUser: userid,
          workKind: "M",
          directYN: "Y", 
          ordNoTmp: ""
        }

        listMstDto.push(data);
      }

      params = {
        mstDtos: listMstDto
      }
    } else {
      if (+item.amt <= 0) {
        this.showAlertPriceInvalid();
        return;
      }
      if (quantity > 0) {      
        let pdtCd = item.pdtCd;
        
        if (ValidationUtil.isNotNullAndNotEmpty(pdtCd)) {
          if (AuthUtil.isLogined()) {
            params = CartUtil.getParamsAddToCart(ConvertUtil.convertToString(pdtCd), quantity, '');
          } else {
            params = {
              comId: environment.comId,
              userid: userid,
              userKindCd: userKindCd,
              cntCd: cntCd,
              pathCD: environment.comCd + "T30",
              pdtCd: ConvertUtil.convertToString(pdtCd),
              qty: quantity,
              workUser: userid,
              workKind: "M",
              directYN: "Y", 
              ordNoTmp: ""
            }
          }
        }  
      } else {
        this.showAlertRequiredQuantityInvalid();
      }
    } 
    
    if (ValidationUtil.isNotNullAndNotEmpty(params)) {
      this._wAlertStore.dispatch(clearWAlert());
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
      this._cartStore.dispatch(setShowAlert({ show: true }));
      this._cartStore.dispatch(setIsBuyNow({ isBuyNow: true }));
      this._cartStore.dispatch(addToCart({ params: params }));
    }    
  }

  showAlertRequiredQuantityInvalid(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: MessageConstant.msgQuantityInvalid } }));
  }

  showAlertPriceInvalid(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: MessageConstant.msgPriceInvalid } }));
  }

  showAlertRequiredLogined(): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.confirm, 
          message: MessageConstant.msgRequiredLogin, 
          action: ActionConstant.actionConfirmLogined 
        } 
      })
    );
  }

  showAlertNotOtherProduct(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: '추가된 상품은 포인트로 결제하는 상품이 아닙니다.' } }));
  }

  showAlertNotPointProduct(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: '포인트로 결제하는 상품은 다른 상품하고 같이 구매할 수 없습니다.' } }));
  }

  showAlertAddCartSuccess(): void {
    //this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: "정상적으로 등록되었습니다." } }));
    this._wAlertStore.dispatch(setWAlert({ 
      wAlert: { 
        icon: WAlertConstant.successful,
        confirmBtnText: '계속쇼핑',
        cancelBtnText: '장바구니',
        action: 'add_cart_confirm', 
        message: ConvertUtil.convertToSring('정상적으로 등록되었습니다.')
      }
    }));
  }

  showListOrdTmp(pdtCd: string, quantity: number, cartInfo: any, cateNameOrg: string): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.warning, 
          message: MessageConstant.msgChooseCart, 
          confirmBtnText: MessageConstant.msgExistCart,
          cancelBtnText: MessageConstant.msgNewCart,
          listCart: cartInfo, 
          action: ActionConstant.actionConfirmAddCart, 
          pdtCd: pdtCd, 
          quantity: quantity,
          cateNameOrg: cateNameOrg
        } 
      })
    );
  }
}